<template>
  <section v-if="slice?.SpotlerId">
    <div class="ct-spotler-product-slider__container container">
      <div class="content-type__content">
        <div
          v-if="slice?.Settings?.Title"
          class="content-type__heading heading heading--2"
        >
          {{ slice.Settings.Title }}
        </div>

        <p
          v-if="slice?.Settings?.Description"
          class="content-type__description"
        >
          {{ slice.Settings.Description }}
        </p>

        <ThirdpartySqueezelyProductSlider :id="slice.SpotlerId" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})
</script>
